import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { BRANDING } from "../config/branding";

async function shrinkQR(base64Png, sizePx = 256) {
  if (!base64Png) return null;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = sizePx;
      c.height = sizePx;
      const ctx = c.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(img, 0, 0, sizePx, sizePx);
      resolve(c.toDataURL("image/png"));
    };
    img.onerror = reject;
    img.src = "data:image/png;base64," + base64Png;
  });
}

function createDoc() {
  return new jsPDF({
    unit: "mm",
    format: "letter",
    compress: true,
    precision: 2,
  });
}

export const DateFormatter = (Fecha) => {
  if (!Fecha) return "";
  const dateObject = new Date(Fecha);
  if (Number.isNaN(dateObject.getTime())) return "";
  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();
  const hours = String(dateObject.getHours()).padStart(2, "0");
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  const seconds = String(dateObject.getSeconds()).padStart(2, "0");
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export const generarPDFFactura = async (venta, resFactura, logoImgEl, options = {}) => {
  const srcDatos = resFactura?.datos || resFactura || {};
  const pick = (...keys) => {
    for (const k of keys) {
      if (srcDatos[k] !== undefined && srcDatos[k] !== null && srcDatos[k] !== "") return srcDatos[k];
    }
    return "";
  };

  const datos = {
    SerieDocumento: pick("SerieDocumento", "Serie", "serie"),
    NumeroDocumento: pick("NumeroDocumento", "Numero", "numero"),
    FechaHoraEmision: pick("FechaHoraEmision", "fecha_emision", "fechaEmision"),
    FechaHoraCertificacion: pick("FechaHoraCertificacion", "fecha_certificacion", "fechaCertificacion"),
    NumeroAutorizacion: pick("NumeroAutorizacion", "autorizacion", "Autorizacion"),
    NombreCertificador: pick("NombreCertificador", "certificador", "Certificador"),
    NITCertificador: pick("NITCertificador", "nit_certificador", "nitCertificador"),
    GranTotal: pick("GranTotal", "total", "Total"),
    TotalImpuesto: pick("TotalImpuesto", "iva", "IVA", "Impuesto"),
    codigoQR: pick("codigoQR", "codigo_qr", "qr", "CodigoQR"),
    NombreReceptor: pick("NombreReceptor"),
    NITReceptor: pick("NITReceptor"),
    DireccionReceptor: pick("DireccionReceptor"),
  };

  const { cliente = {}, detalles = [], id_venta } = venta || {};

  const felBrand = BRANDING?.fel || {};
  const negocio = venta?.negocio || {};
  const felEmisorNombre = String(negocio.razon_social || felBrand?.emisor?.nombre || "").trim();
  const felEmisorNit = String(negocio.nit || felBrand?.emisor?.nit || "").trim();
  const felEst = felBrand?.establecimiento || {};
  const felEstNombre = String(negocio.nombre || felEst?.nombreComercial || "").trim();
  const felEstDireccion = String(negocio.direccion || felEst?.direccion || "").trim();

  const doc = createDoc();
  const qrImageSize = 35;
  const fullQrCodeBase64 = datos.codigoQR ? await shrinkQR(datos.codigoQR, 256) : null;

  if (logoImgEl) doc.addImage(logoImgEl, "PNG", 15, 15, 35, 18);

  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(String(felBrand?.documento?.titulo || "DOCUMENTO TRIBUTARIO ELECTRÓNICO"), 105, 20, {
    align: "center",
  });

  doc.setFontSize(10);
  doc.text(String(felBrand?.documento?.tipo || "FACTURA PEQUEÑO CONTRIBUYENTE"), 105, 26, { align: "center" });

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");

  const xStartDTE = 145;
  const widthDTE = 55;
  const xCenterDTE = xStartDTE + widthDTE / 2;

  doc.setDrawColor(0);
  doc.setLineWidth(1);
  doc.roundedRect(xStartDTE, 15, widthDTE, 55, 3, 3);

  doc.setFontSize(6);
  doc.setFont(undefined, "bold");
  doc.text("DOCUMENTO", xCenterDTE, 20, { align: "center" });
  doc.text("TRIBUTARIO", xCenterDTE, 24, { align: "center" });
  doc.text("ELECTRONICO", xCenterDTE, 28, { align: "center" });
  doc.setFontSize(9);
  doc.text("Factura", xCenterDTE, 33, { align: "center" });

  doc.setFontSize(7);
  doc.setFont(undefined, "normal");
  doc.text("Serie:", xStartDTE + 2, 39);
  doc.text(`${datos.SerieDocumento || ""}`, xStartDTE + 30, 39);
  doc.text("Numero:", xStartDTE + 2, 44);
  doc.text(`${datos.NumeroDocumento || ""}`, xStartDTE + 30, 44);

  doc.setFontSize(7);
  doc.setFont(undefined, "bold");
  doc.text("FECHA EMISION", xCenterDTE, 51, { align: "center" });
  doc.setFont(undefined, "normal");
  doc.setFontSize(6);
  doc.text(DateFormatter(datos.FechaHoraEmision), xCenterDTE, 55, { align: "center" });
  doc.setFontSize(7);
  doc.setFont(undefined, "bold");
  doc.text("MONEDA", xCenterDTE, 60, { align: "center" });
  doc.setFont(undefined, "normal");
  doc.text("GTQ", xCenterDTE, 63, { align: "center" });

  const yBloqueCliente = 45;
  const xTextStart = 40;
  const anchoRectCliente = xStartDTE - 15;

  doc.setFontSize(9);
  doc.setFont(undefined, "normal");

  if (felEmisorNombre || felEmisorNit || felEstNombre || felEstDireccion) {
    doc.setFontSize(9);
    doc.setFont(undefined, "bold");
    if (felEmisorNombre) doc.text(felEmisorNombre, 10, 32);

    doc.setFont(undefined, "normal");
    if (felEstNombre) doc.text(felEstNombre, 10, 36);

    if (felEstDireccion) {
      const addrLines = doc.splitTextToSize(felEstDireccion, anchoRectCliente - 5);
      doc.text(addrLines.slice(0, 2), 10, 40);
    }

    if (felEmisorNit) doc.text(`NIT: ${felEmisorNit}`, 10, 43);
  }

  doc.text("Referencia", 10, yBloqueCliente);

  doc.setDrawColor(0);
  doc.setLineWidth(1);

  const yRectCliente = yBloqueCliente + 3;

  const nombreCliente = cliente?.nombre || datos.NombreReceptor || "CF";
  const nitCliente = cliente?.nit || datos.NITReceptor || "CF";
  const direccionCliente = cliente?.direccion || datos.DireccionReceptor || "Ciudad";

  // Calcular altura del bloque para evitar que se "descuadre" con direcciones largas.
  const maxDirWidth = anchoRectCliente - xTextStart - 5;
  const dirLines = doc.splitTextToSize(String(direccionCliente), Math.max(10, maxDirWidth));
  const maxDirLines = 2;
  const shownDirLines = dirLines.slice(0, maxDirLines);
  const lineH = 5;
  const hRectCliente = 7 + (shownDirLines.length > 1 ? (shownDirLines.length - 1) * lineH : 0) + 16;
  doc.roundedRect(10, yRectCliente, anchoRectCliente, hRectCliente, 3, 3);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text("NOMBRE:", 15, yRectCliente + 5);
  doc.setFont(undefined, "normal");
  doc.text(String(nombreCliente), xTextStart, yRectCliente + 5);

  doc.setFont(undefined, "bold");
  doc.text("NIT:", 15, yRectCliente + 12);
  doc.setFont(undefined, "normal");
  doc.text(String(nitCliente), xTextStart, yRectCliente + 12);

  doc.setFont(undefined, "bold");
  doc.text("DIRECCION:", 15, yRectCliente + 17);
  doc.setFont(undefined, "normal");
  doc.text(shownDirLines, xTextStart, yRectCliente + 17);
  if (dirLines.length > maxDirLines) {
    doc.setFontSize(8);
    doc.setTextColor(90);
    doc.text("...", xTextStart + maxDirWidth - 2, yRectCliente + 17 + (shownDirLines.length - 1) * lineH);
    doc.setTextColor(0);
  }

  const startYTable = Math.max(75, yRectCliente + hRectCliente + 6);

  autoTable(doc, {
    startY: startYTable,
    head: [["CÓDIGO", "CANT.", "DESCRIPCIÓN", "P. UNIT.", "TOTAL"]],
    body: detalles.map((item) => [
      String(item.codigo ?? item.id_producto ?? ""),
      String(item.cantidad ?? ""),
      String(item.descripcion ?? ""),
      `Q${Number(item.precio_unitario ?? 0).toFixed(2)}`,
      `Q${Number(item.total ?? 0).toFixed(2)}`,
    ]),
    theme: "grid",
    styles: {
      fontSize: 8,
      halign: "center",
      valign: "middle",
      lineWidth: 0.2,
      lineColor: [30, 30, 30],
      cellPadding: 2,
      textColor: 20,
    },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      halign: "center",
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 20 }, // codigo
      1: { cellWidth: 14 }, // cant
      2: { cellWidth: 86, halign: "left" }, // descripcion
      3: { cellWidth: 22 }, // p unit
      4: { cellWidth: 22 }, // total
    },
    didParseCell: (data) => {
      // Asegurar que la descripción se alinee a la izquierda.
      if (data.section === "body" && data.column.index === 2) {
        data.cell.styles.halign = "left";
      }
    },
  });

  const finalY = doc.lastAutoTable.finalY + 8;
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  const fraseTexto = String(felBrand?.frase?.texto || "").trim();
  if (fraseTexto) {
    doc.text(fraseTexto, 10, finalY);
  }

  doc.text("Autorización (UUID):", 10, finalY + 5);
  doc.setFont(undefined, "normal");
  doc.text(String(datos.NumeroAutorizacion || ""), 50, finalY + 5);

  doc.setFont(undefined, "bold");
  doc.text("Certificador:", 10, finalY + 10);
  doc.setFont(undefined, "normal");
  doc.text(String(datos.NombreCertificador || felBrand?.certificador?.nombre || ""), 30, finalY + 10);

  doc.setFont(undefined, "bold");
  doc.text("NIT Certificador:", 10, finalY + 15);
  doc.setFont(undefined, "normal");
  doc.text(String(datos.NITCertificador || felBrand?.certificador?.nit || ""), 40, finalY + 15);

  doc.setFont(undefined, "bold");
  doc.text("Fecha certificación:", 10, finalY + 20);
  doc.setFont(undefined, "normal");
  doc.text(DateFormatter(datos.FechaHoraCertificacion), 45, finalY + 20);

  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(`TOTAL: Q${Number(datos.GranTotal || 0).toFixed(2)}`, 150, finalY + 20);

  if (fullQrCodeBase64) {
    doc.addImage(fullQrCodeBase64, "PNG", 160, finalY - 2, qrImageSize, qrImageSize);
  }

  const filename = options.filename || `Factura_${id_venta || datos.NumeroDocumento || "documento"}.pdf`;
  const shouldSave = options.save !== false;
  const onPreview = typeof options.onPreview === "function" ? options.onPreview : null;

  if (onPreview) {
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    onPreview({ url, filename });
    return { url, filename };
  }

  if (shouldSave) doc.save(filename);
  return doc.output("datauristring");
};

export default generarPDFFactura;
